import { render, staticRenderFns } from "./VBarItemOverall.vue?vue&type=template&id=91846140&scoped=true&"
import script from "./VBarItemOverall.vue?vue&type=script&lang=ts&"
export * from "./VBarItemOverall.vue?vue&type=script&lang=ts&"
import style0 from "./VBarItemOverall.vue?vue&type=style&index=0&id=91846140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91846140",
  null
  
)

export default component.exports